import { IDotDangKyNganh2 } from "../../../model/response/quan-ly-nganh-2/IDotDangKyNganh2";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDotDangKyNganh2ActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IDotDangKyNganh2[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as IDotDangKyNganh2 | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IDotDangKyNganh2,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
}

export const eDotDangKyNganh2ActionIds = generateActionTypeIds(eDotDangKyNganh2ActionsObj,"DOT_DANG_KY_NGANH_2");
export type IDotDangKyNganh2ActionTypes = IGenericActionType<typeof eDotDangKyNganh2ActionsObj, "DOT_DANG_KY_NGANH_2">;